import { render, staticRenderFns } from "./feeling.vue?vue&type=template&id=f5f401e4&scoped=true&"
import script from "./feeling.vue?vue&type=script&lang=js&"
export * from "./feeling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f401e4",
  null
  
)

export default component.exports